import React, { forwardRef, useEffect, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  RSelect,
} from "../../components/Component";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { months } from "../../utils/Utils";
import DatePicker from "react-datepicker";
import { Col, FormGroup, Input, Label, Nav, NavItem, Row, TabContent, TabPane, NavLink } from "reactstrap";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getUserReports } from "../../redux/Apislices/reportSlice";
import { getCountry } from "../../redux/Apislices/countrySlice";
import { getprovinceByCountry } from "../../redux/Apislices/provinceSlice";
import { getcityByProvince } from "../../redux/Apislices/citySlice";
import { getneighbourhoodByCity } from "../../redux/Apislices/neighbourhoodSlice";
import classnames from "classnames";
import { PreviewCard } from "../../components/preview/Preview";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import Icon from "../../components/icon/Icon";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const reportTitle = [
  { id: 1, title: "Leads", type: "leads" },
  { id: 2, title: "VIP Agents", type: "vip-agents" },
  { id: 3, title: "Assosiates", type: "associates" },
  { id: 4, title: "Featured Dev", type: "featured-dev" },
  { id: 5, title: "Users/Agents/VIP", type: "users" },
];

const ReportsPage = () => {
  const dispatch = useDispatch();
  const { userReport } = useSelector((state) => ({ userReport: state.report.userReports }));

  const [userData, setUserData] = useState(null);
  const [activeTab, setActiveTab] = useState("leads");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  let usersOptions = {
    maintainAspectRatio: true,
    height: 45,
    width: "100%",
    legend: { display: false },
    scales: {
      x: { gridLines: { color: "#DDDDDD" }, display: true, ticks: { color: "#999999", font: { size: 12 } } },
      y: {
        beginAtZero: true,
        grid: { drawBorder: false, color: "#DDDDDD" },
        ticks: { stepSize: 5, color: "#999999", font: { size: 12 } },
      },
    },
    plugins: { datalabels: { display: false }, legend: { display: false } },
    elements: { bar: { borderRadius: 0 } },
  };
 
  useEffect(() => {
    if (userReport.success) {
      let data = {};
      if (userReport?.type === "monthly") {
        data = {
          labels: months({ count: 12 }),
          datasets: [
            {
              label: "Users",
              data: Object.values(userReport.data.users),
              borderColor: "#cdcdcd",
              backgroundColor: "#cdcdcd",
              stack: "Stack 0",
            },
            {
              label: "Agents",
              data: Object.values(userReport.data.agents),
              borderColor: "#efe3af",
              backgroundColor: "#efe3af",
              stack: "Stack 1",
            },
            {
              label: "VIP Agents",
              data: Object.values(userReport.data.vipAgents),
              borderColor: "#7291c0",
              backgroundColor: "#7291c0",
              stack: "Stack 2",
            },
          ],
        };
      } else if (userReport?.type === "weekly") {
        let max = Math.max(
          Object.values(userReport.data.users)?.length || 0,
          Object.values(userReport.data.agents)?.length || 0,
          Object.values(userReport.data.vipAgents)?.length || 0
        );

        let weeks = Array.from({ length: max }, (v, k) => "Week " + (k + 1));

        data = {
          labels: weeks,
          datasets: [
            {
              label: "Users",
              data: Object.values(userReport.data.users),
              borderColor: "#cdcdcd",
              backgroundColor: "#cdcdcd",
              stack: "Stack 0",
            },
            {
              label: "Agents",
              data: Object.values(userReport.data.agents),
              borderColor: "#efe3af",
              backgroundColor: "#efe3af",
              stack: "Stack 1",
            },
            {
              label: "VIP Agents",
              data: Object.values(userReport.data.vipAgents),
              borderColor: "#7291c0",
              backgroundColor: "#7291c0",
              stack: "Stack 2",
            },
          ],
        };
      } else if (userReport?.type === "custom-range") {
        data = {
          labels: [""],
          datasets: [
            {
              label: "Users",
              data: [userReport.data.users],
              borderColor: "#cdcdcd",
              backgroundColor: "#cdcdcd",
              stack: "Stack 0",
            },
            {
              label: "Agents",
              data: [userReport.data.agents],
              borderColor: "#efe3af",
              backgroundColor: "#efe3af",
              stack: "Stack 1",
            },
            {
              label: "VIP Agents",
              data: [userReport.data.vipAgents],
              borderColor: "#7291c0",
              backgroundColor: "#7291c0",
              stack: "Stack 2",
            },
          ],
        };
      }
      setUserData(data);
    }
  }, [userReport]);

  return (
    <>
      <Head title="Reports" />

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag={"h1"}>
                Reports
              </BlockTitle>
            </BlockHeadContent>

            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content" style={{}}>
                  <ul className="nk-block-tools g-3"></ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className={"mt-2"}>
          <Row>
            <Col lg={12}>
              <ReportForm />
            </Col>

            <Col lg={12} className={"mt-4"}>
              <PreviewCard>
                <Nav tabs className="mt-n3">
                  {reportTitle.map((item, index) => {
                    return (
                      <NavItem key={index} className="pr-1">
                        <NavLink
                          tag="a"
                          href="#tab"
                          className={classnames("px-2", { active: activeTab === item.type })}
                          onClick={(ev) => {
                            ev.preventDefault();
                            toggle(item.type);
                          }}
                        >
                          {item.title}
                        </NavLink>
                      </NavItem>
                    );
                  })}
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={"leads"}>
                    {userData ? (
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <div className="d-flex justify-content-center">
                          {[
                            { color: "#cdcdcd", label: "Presale" },
                            { color: "#efe3af", label: "Assignment" },
                            { color: "#7291c0", label: "MLS" },
                          ]?.map((item, index) => {
                            return (
                              <div key={index} style={{ display: "flex", marginRight: "10px", alignItems: "center" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "30px",
                                    height: "15px",
                                    backgroundColor: item.color,
                                    marginRight: "5px",
                                  }}
                                ></span>
                                <span>{item.label}</span>
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            width: "100%",
                            height: "400px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Bar data={userData} options={usersOptions} />
                        </div>
                      </div>
                    ) : null}
                  </TabPane>
                  <TabPane tabId={"associates"}>
                    <p>
                      Culpa dolor voluptate do laboris laboris irure reprehenderit id incididunt duis pariatur mollit
                      aute magna pariatur consectetur. Eu veniam duis non ut dolor deserunt commodo et minim in quis
                      laboris ipsum velit id veniam. Quis ut consectetur adipisicing officia excepteur non sit. Ut et
                      elit aliquip labore Lorem enim eu. Ullamco mollit occaecat dolore ipsum id officia mollit qui esse
                      anim eiusmod do sint minim consectetur qui.
                    </p>
                  </TabPane>
                  <TabPane tabId={"featured-dev"}>
                    <p>
                      Fugiat id quis dolor culpa eiusmod anim velit excepteur proident dolor aute qui magna. Ad proident
                      laboris ullamco esse anim Lorem Lorem veniam quis Lorem irure occaecat velit nostrud magna nulla.
                      Velit et et proident Lorem do ea tempor officia dolor. Reprehenderit Lorem aliquip labore est
                      magna commodo est ea veniam consectetur.
                    </p>
                  </TabPane>
                  <TabPane tabId={"users"}>
                    {userData ? (
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <div className="d-flex justify-content-center">
                          {[
                            { color: "#cdcdcd", label: "Users" },
                            { color: "#efe3af", label: "Agents" },
                            { color: "#7291c0", label: "VIP Agents" },
                          ]?.map((item, index) => {
                            return (
                              <div key={index} style={{ display: "flex", marginRight: "10px", alignItems: "center" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "30px",
                                    height: "15px",
                                    backgroundColor: item.color,
                                    marginRight: "5px",
                                  }}
                                ></span>
                                <span>{item.label}</span>
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            width: "100%",
                            height: "400px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Bar data={userData} options={usersOptions} />
                        </div>
                      </div>
                    ) : null}
                  </TabPane>
                </TabContent>
              </PreviewCard>

              {/*  */}
              {/*  */}
              {/*  */}
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

const ReportForm = () => {
  const dispatch = useDispatch();
  const { countries, provinces, cities, neighbourhoods } = useSelector((state) => ({
    countries: state.country.countries,
    provinces: state.province.provinceByCountry,
    cities: state.city.cityByProvince,
    neighbourhoods: state.neighbourhood.neighbourhoodByCity,
  }));

  const [year, setYear] = useState("2024");
  const [month, setMonth] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [country, setCountry] = useState(null);
  const [province, setProvince] = useState(null);
  const [city, setCity] = useState(null);
  const [neighbourhood, setNeighbourhood] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();

    let payload = {};
    if (year) payload.year = year;
    if (month) payload.month = month;
    if (startDate) payload.dateFrom = moment(startDate).format("YYYY-MM-DD");
    if (endDate) payload.dateTo = moment(endDate).format("YYYY-MM-DD");
    console.log("payload", payload);

    dispatch(getUserReports(payload));
  };

  useEffect(() => {
    dispatch(getCountry());
  }, [dispatch]);

  useEffect(() => {
    if (typeof country === "object" && country?.value) dispatch(getprovinceByCountry(country.value));
    else dispatch(getprovinceByCountry(""));
  }, [country, dispatch]);

  useEffect(() => {
    if (typeof province === "object" && province?.value) dispatch(getcityByProvince(province.value));
    else dispatch(getcityByProvince(""));
  }, [province, dispatch]);

  useEffect(() => {
    if (typeof city === "object" && city?.value) dispatch(getneighbourhoodByCity(city.value));
    else dispatch(getneighbourhoodByCity(""));
  }, [city, dispatch]);

  return (
    <form onSubmit={onSubmit}>
      <Row className={"g-2"}>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="year" className="form-label">
              Year
            </Label>
            <div className="form-control-wrap">
              <div className="form-control-select">
                <Input type="select" name="select" id="year" value={year} onChange={(e) => setYear(e.target.value)}>
                  <option value="">Select Year</option>
                  {Array.from({ length: 10 }, (v, k) => new Date().getFullYear() - k)
                    .sort()
                    .map((year, index) => {
                      return (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      );
                    })}
                </Input>
              </div>
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="month" className="form-label">
              Month
            </Label>
            <div className="form-control-wrap">
              <div className="form-control-select">
                <Input type="select" name="select" id="month" value={month} onChange={(e) => setMonth(e.target.value)}>
                  {year ? (
                    <>
                      <option value="">Select Month</option>
                      {months({ count: 12 }).map((month, index) => {
                        return (
                          <option key={index} value={month}>
                            {month}
                          </option>
                        );
                      })}
                    </>
                  ) : (
                    <option value="" disabled>
                      Select Year
                    </option>
                  )}
                </Input>
              </div>
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="start-date" className="form-label">
              Start Date
            </Label>
            <div className="form-control-wrap">
              <div className="form-icon form-icon-left">
                <Icon name="calendar"></Icon>
              </div>
              <DatePicker
                id="start-date"
                className="form-control date-picker"
                selected={startDate}
                onChange={setStartDate}
                customInput={<ExampleCustomInput />}
              />
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="end-date" className="form-label">
              End Date
            </Label>
            <div className="form-control-wrap">
              <div className="form-icon form-icon-left">
                <Icon name="calendar"></Icon>
              </div>
              <DatePicker
                id="end-date"
                className="form-control date-picker"
                selected={endDate}
                onChange={setEndDate}
                customInput={<ExampleCustomInput />}
              />
            </div>
          </FormGroup>
        </Col>

        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="country" className="form-label">
              Country
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="country"
                value={country}
                options={
                  countries?.data?.length
                    ? countries?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No Countries found", value: "" }]
                }
                isLoading={countries?.loading}
                isClearable
                placeholder="Country"
                onChange={(value) => {
                  setCountry(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="province" className="form-label">
              Province
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="province"
                value={province}
                options={
                  provinces?.data?.length
                    ? provinces?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No Provinces found", value: "" }]
                }
                isLoading={provinces?.loading}
                isClearable
                placeholder="Province"
                onChange={(value) => {
                  setProvince(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="city" className="form-label">
              City
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="city"
                value={city}
                options={
                  cities?.data?.length
                    ? cities?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No Cities found", value: "" }]
                }
                isLoading={cities?.loading}
                placeholder="City"
                isClearable
                onChange={(value) => {
                  setCity(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup>
            <Label htmlFor="neighbourhood" className="form-label">
              Neighbourhood
            </Label>
            <div className="form-control-wrap">
              <RSelect
                name="neighbourhood"
                value={neighbourhood}
                options={
                  neighbourhoods?.data?.length
                    ? neighbourhoods?.data?.map((li) => ({ label: li.name, value: li._id }))
                    : [{ label: "No Neighbourhoods found", value: "" }]
                }
                isLoading={neighbourhoods?.loading}
                placeholder="Neighbourhood"
                onChange={(value) => {
                  setNeighbourhood(value);
                }}
              />
            </div>
          </FormGroup>
        </Col>

        <Col sm={12}>
          <div
            style={{
              textAlign: "center",
              padding: "10px",
            }}
          >
            <Button type="submit" color="primary">
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </form>
  );
};

const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <div onClick={onClick} ref={ref}>
    <div className="form-icon form-icon-right">
      <Icon name="calendar"></Icon>
    </div>
    <input className="form-control date-picker" type="text" value={value} onChange={onChange} />
  </div>
));

export default ReportsPage;
